import{GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js';
import { Entity } from './entity.js';
import {sceneManager } from '../script.js';
import { showInfoPanel } from '../ui.js';

import { Tail } from '../groupsEntities/tailCometHalley.js'

export class Comet extends Entity {
  constructor(
    size,
    texture,
    orbitRadius,
    axialTilt,
    orbitInclin,
    speedTrans,
    speedRot,
    eccentricity,
    argPeriapsis,
    longAscNode,
    label,
    centerElement
  ) {
    super(centerElement, size, texture, orbitRadius, axialTilt, orbitInclin, speedTrans, speedRot, eccentricity,argPeriapsis,longAscNode, label);

    const blend = new URL('../../../assets/textures/halley/halley.glb',import.meta.url)

    const assetLoader = new GLTFLoader();

    const mesh = this.mesh

    this.tail = new Tail(
      this.mesh,
      centerElement,
      1000
    )


     this.infoIcon.addEventListener('click', (evt) => {
      evt.stopPropagation();
      showInfoPanel(this.name);
    });

    assetLoader.load(blend.href,function(gltf){
      var model = gltf.scene;

      sceneManager.scene.add(model);
      model.position.set(0,0,0)


      model.scale.set(1.72e-7, 1.72e-7, 1.72e-7);

      mesh.add(model)
    },undefined,function(error){
      console.error(error);
    
    });
  }
}
